export default {
  // RejectPhone
  rejectNumber: 'Opt-out Number',
  explanation: 'Description',
  registrationDate: 'Registration Date & Time',
  state: 'Status',
};
